import React from "react";
import { LoadingSpinner, PlainButton } from "@jugl-web/ui-components";
import { ReactComponent as SendIcon } from "./assets/send.svg";

export const ChatInputButton: React.FC<{
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  isLoading?: boolean;
}> = ({ onClick, isLoading, isDisabled }) => (
  <PlainButton
    className="h-10 w-10 rounded-xl bg-primary transition-colors hover:bg-primary-600 disabled:bg-primary-300 disabled:hover:bg-primary-300"
    disabled={isDisabled}
    onClick={onClick}
  >
    {isLoading ? <LoadingSpinner size="sm" /> : <SendIcon />}
  </PlainButton>
);
